var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4531 20.125H25.875C24.7313 20.125 23.6344 19.6706 22.8256 18.8619C22.0169 18.0531 21.5625 16.9562 21.5625 15.8125V3.23438C21.5625 3.13906 21.5246 3.04765 21.4572 2.98026C21.3898 2.91286 21.2984 2.875 21.2031 2.875H12.9375C11.4125 2.875 9.94997 3.4808 8.87164 4.55914C7.7933 5.63747 7.1875 7.10001 7.1875 8.625V37.375C7.1875 38.9 7.7933 40.3625 8.87164 41.4409C9.94997 42.5192 11.4125 43.125 12.9375 43.125H33.0625C34.5875 43.125 36.05 42.5192 37.1284 41.4409C38.2067 40.3625 38.8125 38.9 38.8125 37.375V20.4844C38.8125 20.3891 38.7746 20.2977 38.7072 20.2303C38.6398 20.1629 38.5484 20.125 38.4531 20.125Z",
    fill: "#34495E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6643 16.9439L24.7439 4.02344C24.7187 3.99847 24.6868 3.98147 24.652 3.9746C24.6173 3.96773 24.5813 3.97129 24.5485 3.98483C24.5158 3.99836 24.4878 4.02128 24.468 4.05069C24.4483 4.0801 24.4376 4.1147 24.4375 4.15012V15.8127C24.4375 16.194 24.5889 16.5596 24.8585 16.8292C25.1281 17.0988 25.4938 17.2502 25.875 17.2502H37.5376C37.573 17.2501 37.6076 17.2395 37.6371 17.2197C37.6665 17.2 37.6894 17.172 37.7029 17.1392C37.7165 17.1065 37.72 17.0705 37.7131 17.0357C37.7063 17.001 37.6893 16.969 37.6643 16.9439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.27a95504dccbb9b554a2d657f20bc288.svg";
export { ForwardRef as ReactComponent };